import {CheckoutController} from '@wc-stripe/controllers';
import {getPage, getSetting} from '@wc-stripe/utils';
import Context from '@wc-stripe/context';
import {UniversalPaymentGateway} from '@wc-stripe/gateways';

const settings = getSetting('stripe_upm_data');

const context = new Context(getPage());

const gateway = new UniversalPaymentGateway({
    id: 'stripe_upm',
    settings,
    context
});

const controller = new CheckoutController({
    context,
    gateway,
    selector: '#wc-stripe-upm-element'
});

controller.initialize();